<template>
	<div>
		<modalproduct ref="modalProduct" v-model="dialog" :propAdd='paramProp' :val = 'val' @action="simpan"/>
		<modalconfirm ref="modalconfirmProduct" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Produk</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="() => {dialog=true; paramProp='tambah'; val= {};}">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="productResults" :options.sync="option" :server-items-length="productPagination.total_data" hide-default-footer>
				<template v-slot:item.product_name="{ item }">
					<div class="d-flex">
						<v-avatar size="36">
							<img class="avatar" width="36" :src="item.product_image ? item.product_image : '/assets/produk/produk-def.png'" />
						</v-avatar>
						<div class="pl-2 my-auto">{{ item.product_name }}</div>
					</div>
				</template>
				<template v-slot:item.product_code="{ item }">
					<div class="pb-2">{{ item.product_code }}</div>
				</template>
				<template v-slot:item.product_price="{ item }">
					<div class="pt-2">{{ item.product_price | toNumber }}</div>
				</template>
				<template v-slot:item.product_price_original="{ item }">
					<div class="pt-2">{{ item.product_price_original | toNumber }}</div>
				</template>
				<template v-slot:item.product_weight="{ item }">
					<div class="pt-2">{{ item.product_weight | toNumber }} gr/{{item.product_unit}}</div>
				</template>
				<template v-slot:item.product_is_active="{ item }">
					<v-switch v-model="item.product_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="hapus(item.product_id, item.product_name)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!productPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="productPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="productPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalproduct from '@/views/MLwarehouse/product/ModalProduct'
import {mapActions,  mapState, mapMutations} from 'vuex'

const listStatus = [{
	value: 'active',
	text: 'Aktif'
}, {
	value: 'inactive',
	text: 'Tidak Aktif'
},
]

export default {
	inject: ['theme'],
	components: {
		modalproduct
	},
	data() {
		return {
			sortBy: 'product_name',
			sortDir: 'ASC',
			page: 1,
			limit: 10,
			listLimit: [ 10, 10, 20, 50, 100 ],
			paramProp: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', sortable: true, value: 'product_name'},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Harga Pra MB (Rp)', value: 'product_price', align: 'end', },
			{ text: 'Harga MB (Rp)', value: 'product_price_original', align: 'end', },
			{ text: 'Berat', value: 'product_weight' },
			{ text: 'Kategori', value: 'product_category_name' },
			{ text: 'Aktif', value: 'product_is_active'},
			{ text: 'Aksi', value: 'action', sortable: false, },
			],
			filterData: [{
				type: 'text',
				label: 'Nama Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_name'
				}
			}, {
				type: 'text',
				label: 'Kode Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_code'
				}
			}, {
				type: 'selection',
				label: 'Kategori',
				item: [],
				itemValue: 'product_category_id',
				itemText: 'product_category_name',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_category_id'
				}
			}, {
				type: 'selection',
				label: 'Status',
				item: listStatus,
				itemValue: 'value',
				itemText: 'text',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_is_active'
				}
			},
			],
			include: {
				value: 'true',
				comparison: '=',
				type: 'string',
				field: 'product_is_include'
			},
			notinclude: {
				value: 'false',
				comparison: '=',
				type: 'string',
				field: 'product_is_include'
			},
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('productList', ['productResults', 'productSerialOption', 'serialType', 'productPagination', 'konfirmResponse', 'responSukses', 'productCategory', 'imageName']),
	},
	methods: {
		...mapActions('productList', ['getProduct', 'getProductSerialOption', 'statusProduct', 'deleteProduct', 'getProductUnit', 'getCategoryProduct', 'addProduct', 'updateProduct', 'uploadImage', 'getOptionSerialType', 'exportProduct']),
		...mapMutations('productList', ['konfirmasiSukses']),
		...mapMutations('productList', ['clearDataProduct']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData() {
			let params = [... this.params, this.notinclude]
			this.getProduct(this.queryString({limit:this.limit, page: this.page, params:params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData(){
			let params = [... this.params, this.notinclude]
			this.exportProduct(this.queryString({params:params, sort: this.sortBy, dir: this.sortDir}))
		},
		editStatus(stat){
			this.paramStatus.id = stat.product_id
			if(stat.product_is_active == false){
				this.paramStatus.status = 'inactive'
			} else{
				this.paramStatus.status = 'active'
			}
			this.statusProduct(this.paramStatus).then(() => {
				this.getData()
			})
		},
		hapus(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmProduct.setMessage(msg)
			this.$refs.modalconfirmProduct.showConfirm()
		},
		ubah(item) {
			this.val = item;
			this.dialog = true;
			this.paramProp = 'edit'
		},
		async deleteData () {
			await this.setOverlay(true)
			await this.$refs.modalconfirmProduct.hideConfirm()
			await this.deleteProduct(this.propDelete).then( () => {
				if(this.responSukses.code == 200) {
					this.getData()
				}
			})
			await this.setOverlay(false)
		},
		simpan(value, file) {
			if (file.has('image')) {
				this.uploadImage(file).then( () => {
					value['image'] = this.imageName
					this.saveData(value)
				})
			} else {
				delete value.image
				this.saveData(value)
			}
		},
		async saveData (value) {
      let param = Object.assign({}, value);
      param.is_serial = param.is_serial.map(el => {
        el.serial_name = this.serialType.find(serial => serial.type_id === el.type_id).type_name
        return el
      })
      param.is_serial = JSON.stringify(param.is_serial)

      param.include_product_id = param.include_product_id.map(el => {
        let bundleproduct = this.productSerialOption.find(bundle => bundle.product_id == el.product_id)
        el.product_code = bundleproduct.product_code
        el.product_name = bundleproduct.product_name
        return el
      })
      param.include_product_id = JSON.stringify(param.include_product_id)
			await this.setOverlay(true)
			if(this.paramProp == 'tambah') {
				await this.addProduct(param).then( () => {
					if(this.responSukses.code == 200) {
						this.getData()
						this.dialog = false
						this.reset()
					}
				})
			} else {
				await this.updateProduct(param).then( () => {
					if(this.responSukses.code == 200) {
						this.getData()
						this.dialog = false
						this.reset()
					}
				})
			}
			await this.setOverlay(false)
		},
		reset() {
			this.val = {}
			this.konfirmasiSukses('')
			this.paramProp = '';
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	async created() {
		let indexKategori = await this.filterData.findIndex(el => el.label == 'Kategori')
		this.filterData[indexKategori].item = await this.getCategoryProduct()
		await this.setFilter(this.filterData)

		this.$store.dispatch('setPageTitle', `Produk`)
		this.getProductUnit()
		this.getOptionSerialType()
		this.getProductSerialOption(this.queryString({limit:100, params: [this.include]}))
		this.getData()
	},
	beforeDestroy() {
		this.clearDataProduct()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>


